
function authGuardRoute(to, from, next) {
  var isAuthenticated = false;
  //this is just an example. You will have to find a better or 
  // centralised way to handle you localstorage data handling 
  var getAuth = localStorage.getItem('IsAuthenticated');
  if (getAuth === null) { isAuthenticated = false; }

  if (getAuth) {
    next();
  }
  else {
    next('/login')
  }
}
let rolesAccess = [];
function roleGuardRoute(to, from, next) {
  var getAuth = localStorage.getItem('IsAuthenticated');
  let user = JSON.parse(localStorage.getItem('UserRoles')) //get userRoles
  let menuList = JSON.parse(localStorage.getItem('menuList')) //get userMenus
  const homeSearch = menuList.filter((p) => p.name === "homeSearch"); //get homeSearch menus

  console.log("homeSearch is " + homeSearch)
  const userHomeSearch = [];
  if (homeSearch[0] != undefined) {
    homeSearch[0].children.forEach((element) => {
      userHomeSearch.push(element.name.toLowerCase());
    });
  }

  const lacksRole = to.matched.some(route => {
    rolesAccess = user.filter(p => route.meta.roles.includes(p))
    return route.meta.roles
  })

  // check accessibility rout with name 
  if (lacksRole && (rolesAccess.length <= 0 || getAuth === null || userHomeSearch.filter(p => p.includes(to.name.toLowerCase())).length <= 0)) {
    // localStorage.clear()
    alert('شما به این بخش دسترسی ندارین!!!')
    return next('/')  // Aborts the navigation request
  }
  next()
}


export default [

  {
    path: "hotelFlight",
    name: "hotelFlight",
    beforeEnter: roleGuardRoute,
    component: () => import("./Flight"),

  },

  {
    path: "book",
    name: "FlightHotel Booking",
    beforeEnter: authGuardRoute,
    component: () => import("./Book"),
    meta: { title: 'HF Booking' }
  },
  {
    path: "confirm",
    name: "FlightHotel Confirm",
    beforeEnter: authGuardRoute,
    component: () => import("./Confirm"),
    meta: { title: 'HF Confirm' }
  },
  {
    path: "payment",
    name: "FlightHotel Payment",
    // beforeEnter : guardMyroute,
    component: () => import("./RedirectToBank"),
    meta: { title: 'HF Payment' }
  },
  {
    path: "ticket",
    name: "FlightHotel Ticket",
    // beforeEnter : guardMyroute,
    component: () => import("./Ticket"),
    meta: { title: 'HF Ticket' }
  },
  {
    path: "voucher",
    name: "FlightHotel Voucher",
    // beforeEnter : guardMyroute,
    component: () => import("./VoucherPrint"),
    meta: { title: 'HF Voucher' }
  }
  ,
  {
    path: "error",
    name: "FlightHotel Error",
    component: () => import("./Error"),
    meta: { title: 'HF Error' }
  },
  { path: "**", redirect: "/" },
];
